import { atom, useAtom } from 'jotai';

// Atom to track the count of visible top-sticky banners
export const topStickyBannerCountAtom = atom(0);

// Atom to track the height of the top-sticky banner area
export const topStickyBannerHeightAtom = atom(0);

export const useBannerVisibility = () => {
  const [bannerCount] = useAtom(topStickyBannerCountAtom);

  return bannerCount > 0;
};

export const useBannerHeight = () => {
  const [bannerHeight] = useAtom(topStickyBannerHeightAtom);

  return bannerHeight;
};
